// extracted by mini-css-extract-plugin
export var compactFilters = "_gl-4";
export var detailImage = "_gl-1";
export var dropdownContainer = "_gl-2";
export var imageContainer = "_gl-0";
export var selectedCard = "_gl-3";